import http from './http'
import api from './api'
// import { Notification } from 'element-ui'
import store from 'good-storage'

// let backUrl = '127.0.0.1:8080' // location.origin
let backUrl = location.origin // location.origin

let baseURL = backUrl + '/recurit' // 增加请求默认路径前缀

if (location.href.includes('localhost:8081') || (location.href.includes('192.168.3.15:8081'))) {
  // 前端调试
  baseURL = backUrl + '/api/recurit' // 增加请求默认路径前缀
}

export default {
  currentUsr: null,

  // 下载接口返回流文件后，统一下载接口
  downloadFileForStream (blobData, fileName, fileType) {
    let blob
    if (fileType) {
      blob = new Blob([blobData], {
        type: fileType
      })
    } else {
      blob = new Blob([blobData])
    }
    console.log(blob)
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      // 释放内存
      document.body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    }
  },

  downLoadFile (url, name) {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', baseURL + url, true)
    xhr.responseType = 'blob'
    // let vmThis = this
    xhr.onload = () => {
      if (xhr.status === 200) {
        if (xhr.response && xhr.response.size && xhr.response.size > 0) {
          let file = xhr.response
          let fileName = name
          if ('msSaveOrOpenBlob' in navigator) {
            window.navigator.msSaveOrOpenBlob(file, fileName)
          } else {
            let fileUrl = window.URL.createObjectURL(file)
            let a = document.createElement('a')
            a.download = fileName
            a.href = fileUrl
            document.getElementsByTagName('body')[0].appendChild(a)
            a.click()
            a.parentNode.removeChild(a)
            window.URL.revokeObjectURL(fileUrl)
          }
        }
      } else {
        //
      }
    }
    xhr.setRequestHeader('auth-user', store.get('Authorization'))
    xhr.send()
  },

  isCardID (sId) {
    if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(sId)) {
      console.log('你输入的身份证长度或格式错误')
      return false
    }
    // 身份证城市
    let aCity = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    }
    if (!aCity[parseInt(sId.substr(0, 2))]) {
      console.log('你的身份证地区非法')
      return false
    }

    // 出生日期验证
    let sBirthday = (sId.substr(6, 4) + '-' + Number(sId.substr(10, 2)) + '-' + Number(sId.substr(12, 2))).replace(/-/g, '/')
    let d = new Date(sBirthday)
    if (sBirthday !== (d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate())) {
      console.log('身份证上的出生日期非法')
      return false
    }

    // 身份证号码校验
    let sum = 0
    let weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let codes = '10X98765432'
    for (let i = 0; i < sId.length - 1; i++) {
      sum += sId[i] * weights[i]
    }
    let last = codes[sum % 11] // 计算出来的最后一位身份证号码
    if (sId[sId.length - 1] !== last) {
      console.log('你输入的身份证号非法')
      return false
    }

    return true
  },

  isMobile (s) {
    return /^1[0-9]{10}$/.test(s)
  },

  isEmail (s) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
  },

  checkSensitive (checkObj, callback) {
    http.post(api.checkSensitiveWords.url, checkObj).then(_ => {
      if (_ && _.code !== 200 && _.msg) {
        callback(new Error(`内容含有敏感词汇，请修改`))
      } else {
        callback()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/utilService.js